import { api } from "../../services/api";

export async function fetchHistoricoSaldo({ paginaAtual, itensPorPagina }) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.get("/balancehistory", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      params: {
        page: paginaAtual,
        limit: itensPorPagina
      }
    });

    const data = response.data;

    return {
      dados: data.data || [],
      total: data.total || 0 // Certifique-se que o backend retorna `total`
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
}
